export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  imageUrl: string;
  date: string;
  readTime: string;
  author: string;
  tags: string[];
}

export const categories = [
  { slug: 'platform-intro', name: '平台介绍', icon: 'ri-information-line', count: 5 },
  { slug: 'usage-guide', name: '使用指南', icon: 'ri-book-open-line', count: 6 },
  { slug: 'feature-tutorial', name: '功能教程', icon: 'ri-tools-line', count: 5 },
  { slug: 'latest-news', name: '最新动态', icon: 'ri-flashlight-line', count: 4 },
  { slug: 'faq', name: '常见问题', icon: 'ri-question-answer-line', count: 5 },
];

export const articles: Article[] = [
  {
    slug: 'cheng91-platform-introduction',
    title: '成91平台全面介绍：功能、特色与核心优势',
    excerpt: '成91是一个备受关注的综合性热门平台，本文将为您全面解析成91平台的核心功能、独特优势以及使用体验，帮助您快速了解这个平台的方方面面。',
    content: `<h2>成91平台概述</h2><p>成91是一个集多功能于一体的综合性平台，自上线以来受到了广大用户的热切关注。平台汇聚了丰富的资源和专业的服务团队，通过持续创新和技术升级，为用户打造一流的平台体验。</p><h2>核心功能</h2><p>成91平台提供了一系列强大的核心功能，包括但不限于：智能化内容推荐系统、个性化用户界面定制、高效的数据分析工具以及便捷的社交互动模块。每一项功能都经过精心设计和优化，确保用户能够获得流畅、高效的使用体验。</p><h2>平台特色</h2><p>成91平台的特色在于其对用户体验的极致追求。从简洁直观的界面设计到智能化的功能布局，从快速响应的技术服务到持续迭代的产品更新，成91始终坚持以用户为中心的理念，不断优化和完善平台服务。</p>`,
    category: 'platform-intro',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20digital%20platform%20interface%20with%20sleek%20design%2C%20warm%20orange%20and%20teal%20accents%2C%20clean%20minimalist%20layout%20with%20data%20visualization%20elements%2C%20soft%20natural%20lighting%2C%20professional%20editorial%20style%2C%20harmonious%20composition&width=800&height=500&seq=article-intro-2026&orientation=landscape',
    date: '2026-07-15',
    readTime: '8分钟',
    author: '成91编辑团队',
    tags: ['成91', '平台介绍', '核心功能']
  },
  {
    slug: 'cheng91-quick-start-guide',
    title: '成91使用指南：从零开始的快速上手教程',
    excerpt: '刚刚接触成91平台？不用担心！本指南将从注册账号、功能导航到高级技巧，手把手教你如何快速上手成91平台，轻松掌握所有核心操作。',
    content: `<h2>注册与登录</h2><p>首次使用成91平台，您需要先完成账号注册。注册流程简单快捷，只需提供基本的个人信息即可完成。注册成功后，您可以通过手机号或邮箱登录平台。</p><h2>平台界面导航</h2><p>成91平台的界面设计简洁直观，主要功能模块分布清晰。顶部导航栏包含了首页、分类浏览、文章资讯和关于我们等主要入口。个人中心位于右上角，方便您随时管理账户信息。</p><h2>核心操作指南</h2><p>在成91平台上，您可以轻松浏览各类内容、参与社区讨论、使用各种实用工具。平台提供了智能搜索功能，帮助您快速找到感兴趣的内容。同时，个性化推荐系统会根据您的使用习惯，为您推送最相关的内容。</p>`,
    category: 'usage-guide',
    imageUrl: 'https://readdy.ai/api/search-image?query=Step%20by%20step%20guide%20illustration%20on%20a%20clean%20modern%20interface%2C%20warm%20amber%20accents%2C%20soft%20gradient%20background%2C%20minimalist%20design%20with%20numbered%20steps%2C%20professional%20editorial%20photography%2C%20bright%20and%20airy%20atmosphere&width=800&height=500&seq=article-guide-2026&orientation=landscape',
    date: '2026-07-20',
    readTime: '10分钟',
    author: '成91产品团队',
    tags: ['使用指南', '新手教程', '快速上手']
  },
  {
    slug: 'cheng91-advanced-features',
    title: '成91高级功能介绍：解锁平台的隐藏技能',
    excerpt: '除了基础功能外，成91平台还有许多高级功能等待您发现。本文深入介绍成91的高级特性和使用技巧，帮助您充分发挥平台的潜力。',
    content: `<h2>高级搜索技巧</h2><p>成91平台内置了强大的高级搜索功能，支持多维度筛选和关键词组合搜索。您可以根据时间范围、内容类型、热门程度等条件进行精确搜索，快速定位到所需内容。</p><h2>个性化定制</h2><p>成91提供了丰富的个性化定制选项，您可以根据自己的偏好调整界面布局、主题风格和内容推荐策略。这些定制选项让每位用户都能拥有独一无二的使用体验。</p><h2>数据分析工具</h2><p>对于专业用户，成91平台提供了全面的数据分析工具，帮助您深入了解内容表现、用户行为和趋势变化。这些数据洞察可以为您的决策提供有力支持。</p>`,
    category: 'feature-tutorial',
    imageUrl: 'https://readdy.ai/api/search-image?query=Advanced%20technology%20features%20displayed%20on%20a%20modern%20dashboard%2C%20warm%20coral%20and%20teal%20color%20palette%2C%20clean%20data%20visualization%20with%20charts%20and%20graphs%2C%20minimalist%20UI%20design%2C%20soft%20ambient%20lighting%2C%20professional%20presentation&width=800&height=500&seq=article-advanced-2026&orientation=landscape',
    date: '2026-07-25',
    readTime: '12分钟',
    author: '成91技术团队',
    tags: ['高级功能', '使用技巧', '个性化']
  },
  {
    slug: 'cheng91-security-privacy',
    title: '成91平台安全保障与隐私政策详解',
    excerpt: '用户数据安全是成91平台的重中之重。本文详细介绍了成91平台的安全保障措施和隐私保护政策，让您安心使用平台的各项功能。',
    content: `<h2>数据加密技术</h2><p>成91平台采用业界领先的数据加密技术，所有用户数据在传输和存储过程中都受到严格保护。我们使用端到端加密方案，确保您的个人信息不会被第三方获取。</p><h2>隐私保护政策</h2><p>成91严格遵守相关法律法规，制定了完善的隐私保护政策。我们明确告知用户数据的收集、使用和存储方式，并赋予用户充分的控制权。未经用户明确同意，我们不会将用户数据用于任何非授权用途。</p><h2>安全审计机制</h2><p>平台定期进行安全审计和漏洞扫描，及时发现并修复潜在的安全隐患。我们的安全团队7x24小时监控平台运行状态，确保平台始终处于安全可靠的环境中。</p>`,
    category: 'platform-intro',
    imageUrl: 'https://readdy.ai/api/search-image?query=Digital%20security%20and%20privacy%20concept%20with%20shield%20icon%2C%20warm%20amber%20and%20teal%20accents%20on%20light%20background%2C%20modern%20minimalist%20style%2C%20clean%20composition%20with%20lock%20and%20data%20protection%20elements%2C%20professional%20photography&width=800&height=500&seq=article-security-2026&orientation=landscape',
    date: '2026-07-28',
    readTime: '7分钟',
    author: '成91安全中心',
    tags: ['安全保障', '隐私政策', '数据保护']
  },
  {
    slug: 'cheng91-mobile-experience',
    title: '成91移动端使用体验全面评测',
    excerpt: '移动互联网时代，成91平台的移动端体验如何？本文从界面设计、响应速度、功能完整性等多个维度，对成91移动端进行全面评测。',
    content: `<h2>移动端界面设计</h2><p>成91移动端采用了完全自适应的响应式设计，无论是手机还是平板，都能获得优秀的视觉体验。界面布局经过精心优化，确保在小屏幕设备上依然操作便捷。</p><h2>性能表现</h2><p>在性能方面，成91移动端表现优异。页面加载速度快，交互响应流畅，即使在网络条件不佳的情况下也能保持良好的使用体验。我们对移动端进行了专项性能优化，确保用户随时随地都能畅享平台服务。</p><h2>功能覆盖</h2><p>成91移动端几乎覆盖了桌面端的全部核心功能，包括内容浏览、搜索、个性化推荐等。部分功能在移动端还有独特优化，充分利用了移动设备的特性。</p>`,
    category: 'usage-guide',
    imageUrl: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20a%20modern%20app%20interface%20with%20warm%20orange%20and%20teal%20theme%2C%20held%20in%20hand%20against%20clean%20light%20background%2C%20minimalist%20design%2C%20soft%20natural%20lighting%2C%20editorial%20product%20photography&width=800&height=500&seq=article-mobile-2026&orientation=landscape',
    date: '2026-08-01',
    readTime: '6分钟',
    author: '成91评测团队',
    tags: ['移动端', '使用体验', '评测']
  },
  {
    slug: 'cheng91-community-features',
    title: '成91社区功能深度解析：连接与分享的新方式',
    excerpt: '成91平台的社区功能是其核心亮点之一。本文深度解析成91社区的互动机制、内容创作工具和社交功能，带您领略社区的魅力。',
    content: `<h2>社区互动机制</h2><p>成91社区提供了丰富的互动方式，包括评论、点赞、分享和私信等功能。用户可以在平台上自由交流观点、分享经验，形成活跃的社区氛围。</p><h2>内容创作工具</h2><p>平台内置了强大的内容创作工具，支持图文编辑、多媒体上传和排版美化。无论是发布长文还是分享动态，都能轻松完成。</p><h2>社交网络构建</h2><p>通过关注机制和推荐算法，用户可以轻松发现志同道合的朋友，构建自己的社交网络。平台还定期举办线上活动，促进用户之间的互动和交流。</p>`,
    category: 'feature-tutorial',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vibrant%20online%20community%20concept%20with%20connected%20people%20icons%2C%20warm%20coral%20and%20teal%20accents%2C%20clean%20modern%20interface%20design%2C%20social%20network%20visualization%2C%20soft%20gradient%20background%2C%20professional%20illustration&width=800&height=500&seq=article-community-2026&orientation=landscape',
    date: '2026-08-03',
    readTime: '9分钟',
    author: '成91社区团队',
    tags: ['社区功能', '社交互动', '内容创作']
  },
  {
    slug: 'cheng91-latest-update-2026',
    title: '成91平台2026年8月最新更新公告',
    excerpt: '成91平台持续优化迭代，本月推出了多项重磅更新。本文为您详细解读2026年8月的最新功能变化和优化内容。',
    content: `<h2>界面全新升级</h2><p>本次更新对平台界面进行了全面升级，采用了更加现代化的设计语言。新的界面更加简洁美观，操作体验更加流畅。我们重新设计了导航结构，使功能入口更加清晰易找。</p><h2>性能大幅优化</h2><p>技术团队对平台底层架构进行了深度优化，页面加载速度提升了40%，搜索响应时间缩短了50%。同时，我们引入了新的缓存机制，进一步提升了整体使用体验。</p><h2>新功能上线</h2><p>本月新增了智能推荐2.0、批量操作工具和数据分析仪表盘等多项新功能。这些功能将帮助用户更高效地使用平台，获得更好的使用体验。</p>`,
    category: 'latest-news',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20software%20update%20announcement%20visual%20with%20new%20features%20highlighted%2C%20warm%20amber%20and%20teal%20color%20scheme%2C%20clean%20dashboard%20layout%2C%20minimalist%20design%2C%20soft%20ambient%20light%2C%20professional%20tech%20aesthetic&width=800&height=500&seq=article-update-2026&orientation=landscape',
    date: '2026-08-05',
    readTime: '5分钟',
    author: '成91产品团队',
    tags: ['更新公告', '新功能', '版本更新']
  },
  {
    slug: 'cheng91-user-growth-report',
    title: '成91平台2026上半年用户增长报告',
    excerpt: '成91平台2026年上半年用户数据亮眼，本文通过详实的数据分析，展示成91在用户增长、活跃度和满意度方面的卓越表现。',
    content: `<h2>用户增长数据</h2><p>2026年上半年，成91平台新增注册用户超过500万，同比增长120%。月活跃用户突破1000万大关，日活跃用户达到300万。这些数据充分说明了成91平台的吸引力和用户认可度。</p><h2>用户行为分析</h2><p>根据数据分析，用户平均每日使用时长达到45分钟，人均访问页面数超过20页。用户活跃时间段集中在晚上8点至11点，周末活跃度明显高于工作日。</p><h2>满意度调研</h2><p>最新用户满意度调研显示，98.2%的用户对成91平台表示满意，其中76.5%的用户给出了"非常满意"的评价。用户最满意的三个方面分别是：界面设计、功能丰富度和响应速度。</p>`,
    category: 'latest-news',
    imageUrl: 'https://readdy.ai/api/search-image?query=Business%20growth%20chart%20with%20upward%20trend%20arrows%2C%20warm%20coral%20and%20teal%20accents%2C%20clean%20data%20visualization%20on%20light%20background%2C%20minimalist%20corporate%20style%2C%20soft%20natural%20lighting%2C%20professional%20presentation&width=800&height=500&seq=article-growth-2026&orientation=landscape',
    date: '2026-07-30',
    readTime: '7分钟',
    author: '成91数据团队',
    tags: ['用户增长', '数据报告', '2026']
  },
  {
    slug: 'cheng91-partner-program',
    title: '成91合作伙伴计划：共赢生态的全新篇章',
    excerpt: '成91平台正式推出合作伙伴计划，旨在与更多优质内容创作者和企业建立深度合作关系，共同打造繁荣的平台生态。',
    content: `<h2>计划概述</h2><p>成91合作伙伴计划面向所有优质内容创作者、企业和开发者开放。通过加入合作伙伴计划，您将获得平台提供的流量扶持、技术支持和商业变现机会，与成91共同成长。</p><h2>合作权益</h2><p>合作伙伴将享受包括优先推荐、专属客服、数据分析工具和联合营销等多重权益。平台还将定期举办合作伙伴大会，促进交流与合作。</p><h2>加入方式</h2><p>有意加入合作伙伴计划的用户，可以通过平台内的合作伙伴申请入口提交申请。审核通过后，即可享受合作伙伴的全部权益。</p>`,
    category: 'latest-news',
    imageUrl: 'https://readdy.ai/api/search-image?query=Business%20partnership%20handshake%20concept%2C%20warm%20orange%20and%20teal%20color%20palette%2C%20modern%20minimalist%20style%2C%20clean%20corporate%20illustration%2C%20soft%20gradient%20background%2C%20professional%20photography%20style&width=800&height=500&seq=article-partner-2026&orientation=landscape',
    date: '2026-07-22',
    readTime: '6分钟',
    author: '成91商务团队',
    tags: ['合作伙伴', '生态建设', '共赢']
  },
  {
    slug: 'cheng91-content-creation-tips',
    title: '在成91平台上创作优质内容的十大技巧',
    excerpt: '想在成91平台上脱颖而出？本文总结了十大实用技巧，帮助您提升内容质量，获得更多关注和互动。',
    content: `<h2>了解你的受众</h2><p>在创作内容之前，首先要了解你的目标受众。成91平台提供了详细的受众分析工具，帮助你了解读者的兴趣偏好和行为特征，从而创作更受欢迎的内容。</p><h2>注重内容质量</h2><p>优质的内容始终是吸引用户的核心。确保你的内容具有独特观点、实用价值和良好的可读性。适当使用配图、数据图表等视觉元素，可以大幅提升内容的吸引力。</p><h2>善用平台工具</h2><p>成91平台提供了丰富的内容创作工具，包括排版编辑器、图片处理工具和数据分析面板等。熟练掌握这些工具，可以让你事半功倍。</p>`,
    category: 'feature-tutorial',
    imageUrl: 'https://readdy.ai/api/search-image?query=Creative%20content%20creation%20workspace%20with%20laptop%20and%20notebook%2C%20warm%20amber%20lighting%2C%20clean%20modern%20desk%20setup%2C%20minimalist%20style%2C%20soft%20natural%20light%2C%20professional%20creative%20atmosphere&width=800&height=500&seq=article-content-2026&orientation=landscape',
    date: '2026-07-18',
    readTime: '11分钟',
    author: '成91内容团队',
    tags: ['内容创作', '技巧', '创作指南']
  },
  {
    slug: 'cheng91-faq-account-issues',
    title: '成91账户相关问题解答汇总',
    excerpt: '关于成91平台的账户注册、登录、安全设置等常见问题，本文为您一一解答，帮助您顺利管理自己的账户。',
    content: `<h2>注册相关问题</h2><p>Q: 如何注册成91账号？A: 您可以通过手机号或邮箱注册成91账号，按照页面提示填写相关信息即可完成注册。整个过程只需1-2分钟。</p><p>Q: 注册需要哪些信息？A: 基本注册只需手机号或邮箱和设置密码。后续您可以在个人中心补充更多信息以获得更好的使用体验。</p><h2>登录与安全</h2><p>Q: 忘记密码怎么办？A: 在登录页面点击"忘记密码"，按照提示通过手机号或邮箱验证后即可重设密码。</p><p>Q: 如何开启双重验证？A: 进入个人中心的安全设置页面，按照指引开启手机验证或邮箱验证的双重验证功能。</p>`,
    category: 'faq',
    imageUrl: 'https://readdy.ai/api/search-image?query=Customer%20support%20and%20FAQ%20concept%20with%20question%20marks%2C%20warm%20coral%20and%20teal%20accents%2C%20clean%20modern%20help%20center%20design%2C%20minimalist%20style%2C%20soft%20lighting%2C%20professional%20illustration&width=800&height=500&seq=article-faq-account-2026&orientation=landscape',
    date: '2026-08-02',
    readTime: '5分钟',
    author: '成91客服团队',
    tags: ['常见问题', '账户', 'FAQ']
  },
  {
    slug: 'cheng91-comparison-with-competitors',
    title: '成91与同类平台对比分析：优势在哪里？',
    excerpt: '面对众多同类平台，成91有哪些独特优势？本文从功能、体验、服务和性价比等多个维度，对成91进行全面对比分析。',
    content: `<h2>功能对比</h2><p>与同类平台相比，成91在功能完整性和创新性方面具有明显优势。我们不仅提供了行业标准的基础功能，还自主研发了多项创新功能，为用户带来差异化的使用体验。</p><h2>用户体验</h2><p>在用户体验方面，成91投入了大量资源进行界面优化和性能提升。用户调研显示，成91在操作便捷性、界面美观度和响应速度等方面均领先于同类平台。</p><h2>服务与支持</h2><p>成91提供7x24小时全天候客服支持，平均响应时间仅为3分钟。同时，我们建立了完善的用户反馈机制，确保每一条用户声音都能得到及时响应。</p>`,
    category: 'platform-intro',
    imageUrl: 'https://readdy.ai/api/search-image?query=Side%20by%20side%20comparison%20visual%20of%20two%20digital%20platforms%2C%20warm%20amber%20and%20teal%20accents%20on%20light%20background%2C%20clean%20comparison%20table%20design%2C%20minimalist%20corporate%20style%2C%20professional%20editorial%20photography&width=800&height=500&seq=article-compare-2026&orientation=landscape',
    date: '2026-07-12',
    readTime: '9分钟',
    author: '成91研究团队',
    tags: ['平台对比', '优势分析', '竞品']
  },
  {
    slug: 'cheng91-future-roadmap',
    title: '成91平台未来发展规划与路线图',
    excerpt: '成91团队一直致力于平台的长远发展。本文分享成91的未来规划和产品路线图，让您提前了解平台的发展方向。',
    content: `<h2>近期计划（2026年Q3-Q4）</h2><p>成91将在今年下半年推出多项重要更新，包括全新的AI智能助手、增强型数据分析和跨境服务支持。这些功能将进一步丰富平台生态，提升用户体验。</p><h2>中期愿景（2027年）</h2><p>2027年，成91将重点推进国际化战略，计划拓展至东南亚和欧美市场。同时，我们将加大技术研发投入，在AI和大数据领域持续深耕。</p><h2>长期目标</h2><p>成91的长期目标是成为全球领先的综合性数字平台。我们将始终坚持用户至上的理念，通过持续创新和优质服务，为用户创造更大价值。</p>`,
    category: 'latest-news',
    imageUrl: 'https://readdy.ai/api/search-image?query=Future%20roadmap%20timeline%20visualization%20with%20milestone%20markers%2C%20warm%20coral%20and%20teal%20color%20scheme%2C%20clean%20modern%20presentation%20style%2C%20minimalist%20design%2C%20soft%20gradient%20background%2C%20professional%20illustration&width=800&height=500&seq=article-roadmap-2026&orientation=landscape',
    date: '2026-08-04',
    readTime: '8分钟',
    author: '成91战略团队',
    tags: ['未来规划', '路线图', '发展战略']
  },
  {
    slug: 'cheng91-newbie-mistakes',
    title: '成91新手常见误区及避坑指南',
    excerpt: '很多新用户在初次使用成91平台时会遇到一些常见问题。本文总结了这些常见误区，并提供实用的解决方案。',
    content: `<h2>误区一：忽视个人资料完善</h2><p>很多新用户注册后直接开始使用平台，却忽略了完善个人资料。完善的个人资料不仅能提升账户安全性，还能帮助平台为你提供更精准的推荐。</p><h2>误区二：不了解隐私设置</h2><p>成91提供了丰富的隐私设置选项，但很多用户并不了解这些功能。建议新用户花几分钟时间了解并设置好隐私选项，保护个人信息安全。</p><h2>误区三：不会使用搜索功能</h2><p>成91的搜索功能非常强大，支持多维度筛选和高级搜索。掌握搜索技巧，可以帮你快速找到需要的内容，大幅提升使用效率。</p>`,
    category: 'usage-guide',
    imageUrl: 'https://readdy.ai/api/search-image?query=Warning%20signs%20and%20tips%20illustration%20with%20light%20bulb%20concept%2C%20warm%20amber%20and%20teal%20accents%2C%20clean%20modern%20guide%20design%2C%20minimalist%20style%2C%20soft%20background%2C%20professional%20illustration&width=800&height=500&seq=article-mistakes-2026&orientation=landscape',
    date: '2026-07-16',
    readTime: '7分钟',
    author: '成91用户支持团队',
    tags: ['新手', '避坑', '使用指南']
  },
  {
    slug: 'cheng91-data-analytics-guide',
    title: '成91数据分析工具完全使用手册',
    excerpt: '成91平台内置了强大的数据分析工具，本文从入门到精通，全面介绍如何利用这些工具洞察数据、优化策略。',
    content: `<h2>数据分析面板概览</h2><p>成91数据分析面板提供了全面的数据视图，包括流量趋势、用户画像、内容表现和转化漏斗等核心指标。通过这个面板，您可以快速了解平台运营的整体状况。</p><h2>自定义报表</h2><p>除了预设的数据视图外，您还可以创建自定义报表，根据特定需求选择数据维度和展示方式。自定义报表支持导出功能，方便您进行进一步的分析和分享。</p><h2>数据驱动决策</h2><p>通过分析用户行为数据，您可以发现内容优化的方向、了解用户偏好变化，从而做出更加明智的决策。成91的数据分析工具让数据驱动决策变得简单高效。</p>`,
    category: 'feature-tutorial',
    imageUrl: 'https://readdy.ai/api/search-image?query=Data%20analytics%20dashboard%20on%20a%20modern%20screen%2C%20warm%20amber%20and%20teal%20color%20palette%2C%20clean%20charts%20and%20graphs%2C%20minimalist%20tech%20design%2C%20soft%20ambient%20lighting%2C%20professional%20presentation&width=800&height=500&seq=article-analytics-2026&orientation=landscape',
    date: '2026-07-26',
    readTime: '13分钟',
    author: '成91数据团队',
    tags: ['数据分析', '使用手册', '工具']
  },
  {
    slug: 'cheng91-platform-history',
    title: '成91平台发展历程：从初创到行业领先',
    excerpt: '回顾成91平台的发展历程，从最初的创业想法到如今拥有千万用户的行业领先平台，一路走来充满了创新和突破。',
    content: `<h2>初创阶段</h2><p>成91平台诞生于一个简单的想法：打造一个让用户能够高效获取信息和交流的平台。创始团队凭借对用户需求的深刻理解和对技术的执着追求，开始了成91的开发之旅。</p><h2>快速成长期</h2><p>经过初期的产品打磨和市场验证，成91平台迅速获得了用户的认可。用户数量快速增长，平台功能不断丰富，团队规模也持续扩大。这个阶段奠定了成91快速发展的基础。</p><h2>行业领先</h2><p>如今，成91已发展成为行业领先的综合性平台。我们拥有千万级用户、完善的生态系统和强大的技术能力。但这只是一个开始，成91将继续向前，创造更多可能。</p>`,
    category: 'platform-intro',
    imageUrl: 'https://readdy.ai/api/search-image?query=Company%20history%20timeline%20visualization%20with%20growth%20milestones%2C%20warm%20coral%20and%20teal%20accents%2C%20clean%20modern%20corporate%20design%2C%20minimalist%20style%2C%20soft%20lighting%2C%20professional%20timeline%20illustration&width=800&height=500&seq=article-history-2026&orientation=landscape',
    date: '2026-07-10',
    readTime: '6分钟',
    author: '成91品牌团队',
    tags: ['发展历程', '品牌故事', '成91']
  },
  {
    slug: 'cheng91-troubleshooting-guide',
    title: '成91平台常见技术问题排查指南',
    excerpt: '遇到技术问题不知如何解决？本文整理了成91平台最常见的技术问题及解决方法，帮您快速排查和解决问题。',
    content: `<h2>加载问题</h2><p>如果遇到页面加载缓慢或无法加载的情况，请先检查网络连接。可以尝试刷新页面或清除浏览器缓存。如果问题持续，建议更换浏览器或联系客服支持。</p><h2>显示异常</h2><p>页面显示异常可能是由于浏览器兼容性问题导致的。成91平台推荐使用最新版本的Chrome、Firefox或Safari浏览器。请确保浏览器已更新到最新版本。</p><h2>功能异常</h2><p>如果特定功能无法正常使用，请检查是否有相关权限设置限制。可以在设置页面查看并调整权限。如问题仍未解决，请通过帮助中心提交工单。</p>`,
    category: 'faq',
    imageUrl: 'https://readdy.ai/api/search-image?query=Technical%20support%20and%20troubleshooting%20concept%20with%20tools%20icons%2C%20warm%20amber%20and%20teal%20accents%2C%20clean%20modern%20help%20guide%20design%2C%20minimalist%20style%2C%20soft%20lighting%2C%20professional%20illustration&width=800&height=500&seq=article-trouble-2026&orientation=landscape',
    date: '2026-07-19',
    readTime: '6分钟',
    author: '成91技术支持',
    tags: ['技术问题', '排查指南', 'FAQ']
  }
];

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter(a => a.category === categorySlug);
};

export const getArticleBySlug = (slug: string): Article | undefined => {
  return articles.find(a => a.slug === slug);
};

export const getRelatedArticles = (slug: string, limit: number = 3): Article[] => {
  const current = getArticleBySlug(slug);
  if (!current) return [];
  return articles
    .filter(a => a.slug !== slug && a.category === current.category)
    .slice(0, limit);
};